"use strict";

const html = document.documentElement;
let scrollStart = window.scrollY;

const scrollListener = () => {
    const scrollPosition = window.scrollY;
    const scrollDirection = scrollStart < scrollPosition ? 'down' : 'up';
    const scrollDistance = Math.abs(scrollStart - scrollPosition);

    if (scrollPosition > 200 && scrollDirection === 'down') {
        html.classList.add('header-hidden');
    }

    if (scrollPosition <= 200 || (scrollDirection === 'up' && scrollDistance >= 10)) {
        html.classList.remove('header-hidden');
    }

    scrollStart = scrollPosition;
};
window.addEventListener('scroll', scrollListener);
scrollListener();
